import { trpc } from '../../utils/trpc-client';
import { UserType, ZohoUser } from 'shared/src/domain/user/user-types';

export type UserFilters = {
  accountManagers: ZohoUser[];
  mediaTraders: UserType[];
  clientSuccessDirectors: UserType[];
};

export function useUserFilters() {
  const mediaTraders = trpc.mediaTraders.useQuery();
  const accountManagers = trpc.accountManagers.useQuery();
  const clientSuccessDirectors = trpc.clientSuccessDirectors.useQuery();

  if (mediaTraders.isLoading || accountManagers.isLoading || clientSuccessDirectors.isLoading) {
    return null;
  }
  if (mediaTraders.isError || accountManagers.isError || clientSuccessDirectors.isError) {
    return null;
  }
  if (!mediaTraders.data || !accountManagers.data || !clientSuccessDirectors.data) {
    return null;
  }

  return {
    mediaTraders: mediaTraders.data,
    accountManagers: accountManagers.data,
    clientSuccessDirectors: clientSuccessDirectors.data
  };
}
